import React from 'react';
import { Link } from 'react-router-dom';
import educatorImg from '../../assets/educator.png';

const AboutSection = () => {
  return (
    <section className="max-w-6xl mx-auto mb-20 px-4 flex flex-col md:flex-row items-center gap-12 font-sinhala">
      <div className="flex-1 space-y-6">
        <div className="inline-block px-4 py-1.5 rounded-full bg-red-100 text-red-600 font-bold text-sm tracking-wide mb-2">
          About Us ✨
        </div>
        <h3 className="text-3xl md:text-4xl font-extrabold text-slate-800 drop-shadow-sm">අප ගැන බිඳක්</h3>
        <p className="text-slate-600 leading-loose text-lg">
          කසුන් වලකුඹුර Science අධ්‍යාපන කේන්ද්‍රය මූලිකත්වයෙන් දැනට ලංකාවේ තිබෙන සියලුම Science පන්ති සඳහා ඉංග්‍රීසි හා සිංහල මාධ්‍යයෙන්  උපකාරක පංති පැවැත්වෙන බව අප ඔබ හට දැනුම් දෙන්නේ ඉතාමත් සතුටිනි.
        </p>
        <p className="text-slate-600 leading-loose text-lg">
          Government Syllabus,Edexel Syllabus,Cambridge Syllabus යන සියලුම syllabus වලින් Science පන්ති පවත්වනු ලැබේ.
        </p>
        <p className="text-slate-600 leading-loose text-lg">
          රුහුණු විශ්වවිද්‍යාලයේ B.Sc(Hon's)Biological Science උපාධිදාරියෙක් වන කසුන් වලකුඹුර ගුරුතුමාගේ Science පන්ති වල විශිෂ්ඨත්වය අප වෙත ආ සියලුම දරුවන් හොදින් දනී.
        </p>
        <p className="text-slate-600 leading-loose text-lg">
          මෙතරම් දීර්ඝ ගමනක් පැමිණීමට හැකි වූයේ ඔබ සැම අප කෙරෙහි තිබු විශ්වාසය මත බව අප දනිමු. එම විශ්වාසය ට අප හදවතින් ඔබ හට ස්තූති කරන්නෙමු.
        </p>
        <div className="p-6 bg-gradient-to-r from-orange-50 to-red-50 rounded-r-2xl text-slate-700 leading-loose shadow-sm border-l-4 border-orange-500">
          වසර හතරකට එහා දිවෙන කසුන් වලකුඹුර Science අධ්‍යාපන කේන්ද්‍රය තුළින් අප ලබාදුන් ප්‍රතිඵල බොහෝමය. <span className="text-orange-600 font-bold">ඔබ අප කරා පැමිණෙන අරමුණ ඒ අයුරින්ම ඉෂ්ඨ කර දීම අපගේ මූලික අරමුණයි.</span> අපගේ මූලික ඉලක්කය වන්නේ ඔබගේ අරමුණයි. ඒ අරමුණ කරා ඔබ ගෙන යාම සඳහා අප ගත හැකි සියලුම ක්‍රියාමාර්ග ගනු ලබන්නේ ඉමහත් කැමැත්තෙනි.
        </div>
        <p className="text-slate-600 leading-loose text-lg">
          මේ අයුරින් අපගේ සෙවනට ඔබ පැමිණෙන්නේ අප පසු ගිය සාමාන්‍යපෙල විභාග වලින් ප්‍රථම ස්ථානය ඇතුළු බහුතරයක්  විභාග වලින් සමත් වීම නිසා බව අප දනිමු.
        </p>
        <div className="flex flex-wrap gap-4 pt-4">
          <Link to="/register" className="font-sans inline-block text-center bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-3 px-8 rounded-xl shadow-lg shadow-orange-900/20 hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
            Register Now
          </Link>
          <Link to="/login" className="font-sans inline-block text-center bg-white text-slate-700 font-bold py-3 px-8 rounded-xl border border-slate-200 hover:border-orange-200 hover:bg-orange-50 hover:-translate-y-1 transition-all duration-300 shadow-sm">
            Login
          </Link>
        </div>
      </div>
      
      <div className="relative group perspective-1000">
        <div className="absolute inset-0 bg-gradient-to-tr from-orange-400 to-red-500 rounded-[3rem] blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
        <img src={educatorImg} alt="Kasun Walakumbura" className="relative w-72 md:w-80 h-auto rounded-[3rem] object-cover shadow-2xl ring-1 ring-white/50 transform group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl flex items-center gap-3 animate-bounce">
          <span className="text-2xl">🏆</span>
          <div className="text-sm font-bold text-slate-800">Best Educator<br/><span className="text-orange-500 font-normal">Award Winning</span></div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
